/**
 * Document API Functions
 * ドキュメント関連のAPI操作
 */

import {
    aiUsage,
    allTenantFeatureSetting
} from '@/LantanaAPI/graphql/queries';
import {
    createDocumentUrl,
    deleteDocument as mutationDeleteDocument,
    permanentlyDeleteDocument,
    getLinkServiceToken
} from '@/LantanaAPI/graphql/mutations';

import { executeQuery, executeMutation } from '../core/client';

/**
 * AI使用量を取得
 */
export async function getAiUsage(service: string, month: string) {
    return executeQuery(aiUsage, { service, month });
}

/**
 * テナントフィーチャー設定一覧を取得
 */
export async function getAllTenantFeatureSettings() {
    return executeQuery(allTenantFeatureSetting);
}

/**
 * ドキュメントURLを作成
 */
export async function createNewDocumentUrl(input: any) {
    return executeMutation(createDocumentUrl, { input });
}

/**
 * ドキュメントを削除（ゴミ箱へ移動）
 * @param serialId デバイスのシリアルID
 * @param documentName ドキュメント名
 */
export async function removeDocument(input: { serialId: string; documentName: string }): Promise<{ serialId: string; documentName: string }> {
    await executeMutation(mutationDeleteDocument, { input });
    // 既存APIの戻り値形式に合わせる
    return { serialId: input.serialId, documentName: input.documentName };
}

/**
 * ドキュメントを削除(ラッパー)
 */
export async function deleteDocument(serialId: string, documentName: string): Promise<{ serialId: string; documentName: string }> {
    return removeDocument({ serialId, documentName });
}

/**
 * ドキュメントを完全削除
 */
export async function permanentlyRemoveDocument(input: any) {
    return executeMutation(permanentlyDeleteDocument, { input });
}

/**
 * kintoneの連携サービストークンを取得
 */
export async function getKintoneToken(): Promise<{ token: string; endpoint: string }> {
    try {
        const result = await executeMutation(getLinkServiceToken, {
            input: { service: "kintone" }
        });

        const tokenData = result.getLinkServiceToken;
        const token = tokenData?.accessToken?.token ?? "";
        const endpoint = tokenData?.endpointUrl ?? "";

        return { token, endpoint };
    } catch (error) {
        // エラー時は空文字を返す（既存動作を維持）
        return { token: '', endpoint: '' };
    }
}
